import {
    Box,
    Button,
    Flex,
    Icon,
    Image,
    List,
    Menu,
    Portal,
    Separator,
    SimpleGrid,
    Spinner,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { CaretDownIcon } from "@phosphor-icons/react/dist/ssr";
import { DotIcon } from "@phosphor-icons/react/dist/ssr";
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import { isPortrait } from "@/utilities/useOrientation";

import Header from "./Header";

const ContentSelection = ({
    data,
    options,
    setOptions,
    viewSelected,
    setViewSelected,
    developmentData,
    setOptionsTowers,
    setStep,
    step,
}) => {
    const [unitSelected, setUnitSelected] = useState(null);
    const [unitSelectedId, setUnitSelectedId] = useState(null);
    const [routeUser, setRouteUser] = useState(null);
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const orientation = isPortrait() ? "portrait" : "landscape";

    const loadSvg = () => {
        const svg = document.getElementById("svg");
        if (svg) {
            // ==== VALIDATE TO IDENTIFY TYPE OF TAG ON IMAGE SVG ====
            let elementTagName = null;
            const rect = Array.from(svg.getElementsByTagName("rect"));
            const path = Array.from(svg.getElementsByTagName("path"));
            path.forEach((paths) => {
                paths.style.cursor = "pointer";
            });
            elementTagName = rect.concat(path);
            // ==== RUN ARRAY TO SET COLORS DEPENDING OF THE STATUS ====
            for (let ind = 0; ind < data.length; ind++) {
                const elementData = data[ind];
                for (let i = 0; i < elementTagName.length; i++) {
                    const element = elementTagName[i];

                    for (let index = 0; index < elementData?.property_props?.length; index++) {
                        const model = elementData.property_props[index];
                        if (model.property_id === element.id) {
                            if (model.status === "ACTIVE") {
                                element.setAttribute("fill", "#00E503");
                                element.setAttribute("fill-opacity", 0.3);
                            } else if (model.status === "APART") {
                                element.setAttribute("fill", "#FFF300");
                                element.setAttribute("fill-opacity", 0.4);
                            } else {
                                element.setAttribute("fill", "#D80000");
                                element.setAttribute("fill-opacity", 0.3);
                            }
                            break;
                        }
                    }
                }
            }
        }
    };

    useEffect(() => {
        setUnitSelected(null);
        setUnitSelectedId(null);
        const user_route = ["Vista General"];
        if (viewSelected) {
            const tower = viewSelected?.outter_dimension_props?.filter(
                (item) => item?.dimension_name?.toUpperCase() == "TOWER"
            );
            if (tower && tower.length > 0) {
                user_route.push(tower[0]?.item_name);
            }
            const view = `Vista ${viewSelected?.item_name}`;
            user_route.push(view.toLowerCase());
            setRouteUser(user_route);
        }
    }, [viewSelected]);

    useEffect(() => {
        if (data) {
            const options_ = [];
            const towers = [];

            // Filtrar y agrupar los elementos por `map_image_url`
            const groupedByImage = data.reduce((acc, element) => {
                const imageUrl = element?.map_image_url;
                if (imageUrl) {
                    acc[imageUrl] = acc[imageUrl] || [];
                    acc[imageUrl].push(element);
                }
                return acc;
            }, {});

            /* data */ Object.values(groupedByImage).map((element) => {
                if (
                    element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    )
                ) {
                    let tower = element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    );
                    towers.push(tower[0]?.item_name);
                }
            });
            const towers_ = [...new Set(towers)];
            /* data */ Object.values(groupedByImage).map((element) => {
                if (element[0].map_image_url !== null) {
                    const tower = element[0]?.outter_dimension_props?.filter(
                        (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                    );

                    let concat = `${tower[0]?.item_name && towers_.length > 1 ? tower[0]?.item_name + " / " : ""} ${element[0]?.item_name ? element[0]?.item_name : ""}`;
                    const option = {
                        ...element[0],
                        name_option: concat?.toUpperCase(),
                        tower: tower[0]?.item_name,
                    };
                    options_.push(option);
                }
            });
            setOptions(options_);
            setOptionsTowers(towers_?.sort((a, b) => a.localeCompare(b)));
            if (!viewSelected) setViewSelected(options_[0]);
            else {
                const regex_uuid = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
                const view_uuid = regex_uuid.test(viewSelected);
                if (view_uuid) {
                    setViewSelected(options_.find((option) => option.id === viewSelected));
                }
            }
        }
    }, [data]);

    const handleSelect = (e) => {
        const id = e.target.id;
        const depa = document.getElementById(id);
        const depaColor = depa.getAttribute("fill");
        let flag = true;

        if (id.length >= 15) {
            if (depaColor !== "#D80000" && depaColor !== "#FFF300" && !depaColor.includes("url")) {
                // ==== CHANGE COLOR OF APARTMENT SELECTED ====
                if (
                    id.includes("sur") === false &&
                    id.includes("Sur") === false &&
                    id.includes("oriente") === false &&
                    id.includes("Oriente") === false &&
                    id.includes("norte") === false &&
                    id.includes("Norte") === false &&
                    id.includes("poniente") === false &&
                    id.includes("Poniente") === false
                ) {
                    if (!unitSelectedId) {
                        setUnitSelectedId(depa);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                    } else if (unitSelectedId && unitSelectedId !== id) {
                        const prevDepa = unitSelectedId;
                        prevDepa.setAttribute("fill", "#00E503");
                        prevDepa.setAttribute("fill-opacity", 0.3);
                        depa.setAttribute("fill", "#FFFFFF");
                        depa.setAttribute("fill-opacity", 0.6);
                        setUnitSelectedId(depa);
                    }
                }
                // ==== SHOW PHOTO AND DATA OF APARTMENT ====
                if (viewSelected?.property_props != null) {
                    viewSelected?.property_props.forEach((element) => {
                        if (element.property_id === id) {
                            setUnitSelected(element);
                            if (
                                !isGreaterThanMd ||
                                (isGreaterThanMd && orientation == "portrait")
                            ) {
                                setStep(3);
                            }
                            parent.postMessage(element);
                            if (viewSelected) {
                                const user_route = ["Vista General"];
                                const tower = viewSelected?.outter_dimension_props?.filter(
                                    (item) => item?.dimension_name?.toUpperCase() == "TOWER"
                                );
                                if (tower && tower.length > 0) {
                                    user_route.push(tower[0]?.item_name);
                                }
                                const view = `Vista ${viewSelected?.item_name}`;
                                user_route.push(view.toLowerCase());
                                const model = `Modelo ${element?.model_name?.toLowerCase()}`;
                                user_route.push(model);
                                setRouteUser(user_route);
                            }
                            flag = false;
                        }
                    });
                }

                if (flag) {
                    data.forEach((d) => {
                        if (d.property_props != null) {
                            d.property_props.forEach((property) => {
                                if (property.property_id === id) {
                                    setUnitSelected(property);
                                    if (
                                        !isGreaterThanMd ||
                                        (isGreaterThanMd && orientation == "portrait")
                                    ) {
                                        setStep(3);
                                    }
                                    parent.postMessage(property);
                                }
                            });
                        }
                    });
                }
            }
        }
    };

    const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 0,
    });

    const handleClick = (item, index) => {
        if (index == 0) {
            setStep(1);
        }
    };

    const handleSetStep = (step_) => {
        setStep(step - 1);
        setUnitSelected(null);
    };

    return (
        <Box w="100vw" height="100vh" bgColor="#FFFFFF">
            <Header developmentData={developmentData} step={step} setStep={handleSetStep} />
            <Flex
                gap={{ base: 2, lg: 10 }}
                direction={{
                    base: "column",
                    lg: isGreaterThanMd && orientation == "portrait" ? "column" : "row",
                }}
                px="4vw"
                pt={{ base: "8vh", md: "10vh", lg: "10vh" }}
            >
                {
                    <Box minW={{ base: "100%", lg: "40%" }}>
                        <Stack
                            my={{
                                base: 2,
                                lg: isGreaterThanMd && orientation == "portrait" ? 2 : 4,
                            }}
                        >
                            <Flex>
                                {routeUser?.map((item, index) => (
                                    <Flex key={index}>
                                        <Text
                                            fontWeight="400"
                                            fontSize={{ base: "1.5vh", lg: "1.7vh" }}
                                            color="#000000"
                                            textTransform="capitalize"
                                            cursor={index == 0 ? "pointer" : "default"}
                                            onClick={() => handleClick(item, index)}
                                            _hover={{
                                                textDecoration: index == 0 ? "underline" : "none",
                                            }}
                                        >
                                            {item}
                                        </Text>
                                        {index !== routeUser.length - 1 && (
                                            <span
                                                style={{
                                                    marginLeft:
                                                        isGreaterThanMd &&
                                                        orientation == "landscape"
                                                            ? "0.5vw"
                                                            : "1vw",
                                                    marginRight:
                                                        isGreaterThanMd &&
                                                        orientation == "landscape"
                                                            ? "0.5vw"
                                                            : "1vw",
                                                    fontSize:
                                                        isGreaterThanMd &&
                                                        orientation == "landscape"
                                                            ? "2vh"
                                                            : "1.7vh",
                                                }}
                                            >
                                                {" "}
                                                {">"}{" "}
                                            </span>
                                        )}
                                    </Flex>
                                ))}
                            </Flex>
                        </Stack>
                        {(!isGreaterThanMd || (isGreaterThanMd && orientation == "portrait")) &&
                            step != 3 && (
                                <>
                                    <Stack>
                                        <Text
                                            fontSize={{ base: "2vh", lg: "2.5vh" }}
                                            fontWeight={700}
                                            color="black"
                                            fontFamily="Montserrat"
                                        >
                                            ¡Elige la unidad para ti!
                                        </Text>
                                        <List.Root as="ol" pl={4} gap={4}>
                                            <List.Item
                                                fontSize={{ base: "1.7vh", lg: "1.5vh" }}
                                                fontWeight={400}
                                                color="black"
                                                fontFamily="Montserrat"
                                            >
                                                Selecciona la vista que desees en el recuadro
                                                ubicado en la parte superior derecha de la imagen.
                                            </List.Item>
                                            <List.Item
                                                fontSize={{ base: "1.7vh", lg: "1.5vh" }}
                                                fontWeight={400}
                                                color="black"
                                                fontFamily="Montserrat"
                                            >
                                                Da clic sobre el nivel y la unidad de tu interés
                                                para conocer todos los detalles.
                                            </List.Item>
                                        </List.Root>
                                    </Stack>
                                    <Flex direction="column" h="90%" justifyContent="space-around">
                                        <Stack alignItems="center" mt="2vh">
                                            <Flex
                                                gap={{ base: 2, lg: 4 }}
                                                direction={{ base: "row", lg: "row" }}
                                            >
                                                <Flex gap={3} alignItems="center">
                                                    <Box
                                                        bg="#B6C768"
                                                        w={{
                                                            base: unitSelected ? "4vw" : "7vw",
                                                            lg: "5vw",
                                                        }}
                                                        h="2vh"
                                                        rounded="md"
                                                    />

                                                    <Text
                                                        color={
                                                            developmentData?.branding_props
                                                                ?.sidebar_accent_text ||
                                                            developmentData?.branding_props
                                                                ?.accent_text ||
                                                            "#002B49"
                                                        }
                                                        fontSize={{
                                                            base: unitSelected ? "1.2vh" : "1.25vh",
                                                            lg: "1.4vh",
                                                        }}
                                                        fontWeight={400}
                                                    >
                                                        Disponible
                                                    </Text>
                                                </Flex>
                                                <Flex gap={3} alignItems="center">
                                                    <Box
                                                        bg="#DD4042"
                                                        w={{
                                                            base: unitSelected ? "4vw" : "7vw",
                                                            lg: "5vw",
                                                        }}
                                                        h="2vh"
                                                        rounded="md"
                                                    />

                                                    <Text
                                                        color={
                                                            developmentData?.branding_props
                                                                ?.sidebar_accent_text ||
                                                            developmentData?.branding_props
                                                                ?.accent_text ||
                                                            "#002B49"
                                                        }
                                                        fontSize={{
                                                            base: unitSelected ? "1.2vh" : "1.25vh",
                                                            lg: "1.4vh",
                                                        }}
                                                        fontWeight={400}
                                                    >
                                                        Vendido o en proceso
                                                    </Text>
                                                </Flex>
                                                <Flex gap={3} alignItems="center">
                                                    <Box
                                                        bg="#F6CC00"
                                                        w={{
                                                            base: unitSelected ? "4vw" : "7vw",
                                                            lg: "5vw",
                                                        }}
                                                        h="2vh"
                                                        rounded="md"
                                                    />

                                                    <Text
                                                        color={
                                                            developmentData?.branding_props
                                                                ?.sidebar_accent_text ||
                                                            developmentData?.branding_props
                                                                ?.accent_text ||
                                                            "#002B49"
                                                        }
                                                        fontSize={{
                                                            base: unitSelected ? "1.2vh" : "1.25vh",
                                                            lg: "1.4vh",
                                                        }}
                                                        fontWeight={400}
                                                    >
                                                        Apartado
                                                    </Text>
                                                </Flex>
                                            </Flex>
                                        </Stack>
                                        <Stack mt="3vh" mb="2vh" alignItems="center">
                                            <Menu.Root>
                                                <Menu.Trigger
                                                    asChild
                                                    textTransform="capitalize"
                                                    background="white"
                                                    color="#4F4F4FFA"
                                                    fontWeight={400}
                                                    borderWidth={1}
                                                    borderColor="#888888"
                                                    rounded="full"
                                                    w="fit-content"
                                                    textAlign="left"
                                                    fontSize={{ base: "2vh", lg: "1.7vh" }}
                                                    p={{ base: "2vh", lg: "1.7vh" }}
                                                    _hover={{
                                                        background: "#F0F0F0",
                                                    }}
                                                    _open={{ background: "#F0F0F0" }}
                                                >
                                                    <Button justifyContent="space-between" px={6}>
                                                        {!viewSelected
                                                            ? "Selecciona una vista"
                                                            : viewSelected?.name_option?.toLowerCase()}
                                                        <Icon ml={2} boxSize={4}>
                                                            <CaretDownIcon weight="bold" />
                                                        </Icon>
                                                    </Button>
                                                </Menu.Trigger>
                                                <Portal>
                                                    <Menu.Positioner>
                                                        <Menu.Content
                                                            shadow="lg"
                                                            minW="200px"
                                                            py={2}
                                                        >
                                                            {options.map((item, index) => (
                                                                <Menu.Item
                                                                    key={index}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setViewSelected(item);
                                                                    }}
                                                                    textTransform="capitalize"
                                                                    fontSize={{
                                                                        base: "2vh",
                                                                        lg: "1.7vh",
                                                                    }}
                                                                    p={2}
                                                                    _hover={{
                                                                        background: "#F0F0F0",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    {item?.name_option?.toLowerCase()}
                                                                </Menu.Item>
                                                            ))}
                                                        </Menu.Content>
                                                    </Menu.Positioner>
                                                </Portal>
                                            </Menu.Root>
                                        </Stack>
                                    </Flex>
                                </>
                            )}
                        {step != 3 &&
                            (viewSelected ? (
                                <Box
                                    position="relative"
                                    width="100%"
                                    mt="30px"
                                    mr={{ base: "0", lg: "20px" }}
                                >
                                    <SVG
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            maxHeight:
                                                isGreaterThanMd && orientation == "landscape"
                                                    ? "75vh"
                                                    : isGreaterThanMd && orientation == "portrait"
                                                      ? "55vh"
                                                      : "50vh",
                                            minHeight:
                                                isGreaterThanMd && orientation == "landscape"
                                                    ? "70vh"
                                                    : isGreaterThanMd && orientation == "portrait"
                                                      ? "55vh"
                                                      : "50vh",
                                        }}
                                        id="svg"
                                        src={viewSelected?.map_image_url}
                                        cursor="pointer"
                                        onClick={(e) => handleSelect(e)}
                                        onLoad={loadSvg}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    position="relative"
                                    width="100%"
                                    /*  mb={'70px'} */ mt="30px"
                                    mr={{ base: "0", lg: "20px" }}
                                    justifyContent="center"
                                >
                                    <Spinner />
                                </Box>
                            ))}
                    </Box>
                }
                {isGreaterThanMd && orientation == "landscape" && (
                    <Box minW={{ base: "100%", lg: "55%" }}>
                        <Stack mt="3vh" mb="2vh" alignItems="center">
                            <Menu.Root>
                                <Menu.Trigger
                                    asChild
                                    textTransform="capitalize"
                                    background="white"
                                    color="#4F4F4FFA"
                                    fontWeight={400}
                                    borderWidth={1}
                                    borderColor="#888888"
                                    rounded="full"
                                    w={{ base: "100%", lg: "fit-content" }}
                                    textAlign="left"
                                    fontSize={{ base: "2vh", lg: "1.7vh" }}
                                    p={{ base: "2vh", lg: "1.7vh" }}
                                    _hover={{
                                        background: "#F0F0F0",
                                    }}
                                    _open={{ background: "#F0F0F0" }}
                                >
                                    <Button justifyContent="space-between" px={6}>
                                        {!viewSelected
                                            ? "Selecciona una vista"
                                            : viewSelected?.name_option?.toLowerCase()}
                                        <Icon ml={2} boxSize={4}>
                                            <CaretDownIcon weight="bold" />
                                        </Icon>
                                    </Button>
                                </Menu.Trigger>
                                <Portal>
                                    <Menu.Positioner>
                                        <Menu.Content shadow="lg" minW="200px" py={2}>
                                            {options.map((item, index) => (
                                                <Menu.Item
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setViewSelected(item);
                                                    }}
                                                    textTransform="capitalize"
                                                    fontSize={{ base: "2vh", lg: "1.7vh" }}
                                                    p={2}
                                                    _hover={{
                                                        background: "#F0F0F0",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {item?.name_option?.toLowerCase()}
                                                </Menu.Item>
                                            ))}
                                        </Menu.Content>
                                    </Menu.Positioner>
                                </Portal>
                            </Menu.Root>
                        </Stack>
                        {!unitSelected && isGreaterThanMd ? (
                            <>
                                <Stack>
                                    <Text
                                        fontSize={{ base: "3vh", lg: "2.5vh" }}
                                        fontWeight={700}
                                        color="black"
                                    >
                                        ¡Elige la unidad para ti!
                                    </Text>
                                    <Text
                                        fontSize={{ base: "2vh", lg: "1.7vh" }}
                                        fontWeight={400}
                                        color="black"
                                    >
                                        1. Selecciona la vista que desees en el recuadro ubicado en
                                        la parte superior derecha de la imagen.
                                    </Text>
                                    <Text
                                        fontSize={{ base: "2vh", lg: "1.7vh" }}
                                        fontWeight={400}
                                        color="black"
                                    >
                                        2. Da clic sobre el nivel y la unidad de tu interés para
                                        conocer todos los detalles.
                                    </Text>
                                </Stack>
                                <Flex direction="column" h="90%" justifyContent="space-around">
                                    <Stack alignItems="center" mt="2vh">
                                        <Text
                                            fontSize={{ base: "2vh", lg: "1.7vh" }}
                                            fontWeight={400}
                                            mb={{ base: "1.5vh", lg: "2vh" }}
                                        >
                                            Selecciona un departamento
                                        </Text>
                                        <Image
                                            src="https://media.grupoguia.mx/vision/icon/clic.svg"
                                            alt="click"
                                            w={{ base: "100%", lg: "auto" }}
                                            maxH={{ base: "5vh", lg: "20vh" }}
                                            minH={{ base: "5vh", lg: "15vh" }}
                                        />
                                    </Stack>
                                    <Stack alignItems="center" mt="2vh">
                                        <Flex
                                            gap={6}
                                            direction={{
                                                base: unitSelected ? "row" : "column",
                                                lg: "row",
                                            }}
                                        >
                                            <Flex gap={3} alignItems="center">
                                                <Box
                                                    bg="#B6C768"
                                                    w={{
                                                        base: unitSelected ? "4vw" : "10vw",
                                                        lg: "2.6vw",
                                                    }}
                                                    h="2vh"
                                                    rounded="md"
                                                />

                                                <Text
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_accent_text ||
                                                        developmentData?.branding_props
                                                            ?.accent_text ||
                                                        "#002B49"
                                                    }
                                                    fontSize={{
                                                        base: unitSelected ? "1.2vh" : "2vh",
                                                        lg: "2vh",
                                                    }}
                                                    fontWeight={400}
                                                >
                                                    Disponible
                                                </Text>
                                            </Flex>
                                            <Flex gap={3} alignItems="center">
                                                <Box
                                                    bg="#DD4042"
                                                    w={{
                                                        base: unitSelected ? "4vw" : "10vw",
                                                        lg: "2.6vw",
                                                    }}
                                                    h="2vh"
                                                    rounded="md"
                                                />

                                                <Text
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_accent_text ||
                                                        developmentData?.branding_props
                                                            ?.accent_text ||
                                                        "#002B49"
                                                    }
                                                    fontSize={{
                                                        base: unitSelected ? "1.2vh" : "2vh",
                                                        lg: "2vh",
                                                    }}
                                                    fontWeight={400}
                                                >
                                                    Vendido o en proceso
                                                </Text>
                                            </Flex>
                                            <Flex gap={3} alignItems="center">
                                                <Box
                                                    bg="#F6CC00"
                                                    w={{
                                                        base: unitSelected ? "4vw" : "10vw",
                                                        lg: "2.6vw",
                                                    }}
                                                    h="2vh"
                                                    rounded="md"
                                                />

                                                <Text
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_accent_text ||
                                                        developmentData?.branding_props
                                                            ?.accent_text ||
                                                        "#002B49"
                                                    }
                                                    fontSize={{
                                                        base: unitSelected ? "1.2vh" : "2vh",
                                                        lg: "2vh",
                                                    }}
                                                    fontWeight={400}
                                                >
                                                    Apartado
                                                </Text>
                                            </Flex>
                                        </Flex>
                                    </Stack>
                                </Flex>
                            </>
                        ) : (
                            isGreaterThanMd &&
                            orientation === "landscape" && (
                                <Flex
                                    minW="30vw"
                                    maxW={{ base: "100%", lg: "100%" }}
                                    justifyItems="center"
                                    mt="2vh"
                                    direction="column"
                                    justifyContent={
                                        developmentData?.branding_props?.details_justify ||
                                        "space-between"
                                    }
                                    maxH="75vh"
                                    overflowY="auto"
                                    gap="1vw"
                                >
                                    <Stack>
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_accent_text ||
                                                developmentData?.branding_props?.accent_text ||
                                                "#000"
                                            }
                                            fontSize={{ base: "2.2vh", lg: "2.4vh" }}
                                            fontWeight={700}
                                            textTransform="capitalize"
                                            textAlign="center"
                                            fontFamily="Montserrat"
                                        >
                                            Unidad seleccionada
                                        </Text>
                                    </Stack>
                                    <Flex gap="0.5vw">
                                        <Stack>
                                            <Flex gap="1vw" mt="1vh" alignItems="end">
                                                <Text
                                                    color={
                                                        "#000" ||
                                                        developmentData?.branding_props
                                                            ?.sidebar_accent_text ||
                                                        developmentData?.branding_props
                                                            ?.accent_text ||
                                                        "#002B49"
                                                    }
                                                    fontSize={{ base: "2.2vh", lg: "2.6vh" }}
                                                    fontWeight={700}
                                                    textTransform="capitalize"
                                                    textAlign="start"
                                                    fontFamily="Poppins"
                                                    textShadow="0px 1.5px 1.5px #636363"
                                                >
                                                    Modelo {unitSelected?.model_name?.toLowerCase()}
                                                </Text>
                                                <Text
                                                    color={
                                                        developmentData?.branding_props
                                                            ?.sidebar_accent_text ||
                                                        developmentData?.branding_props
                                                            ?.accent_text ||
                                                        "#002B49"
                                                    }
                                                    fontSize={{ base: "1.5vh", lg: "2.4vh" }}
                                                    fontWeight={400}
                                                    textTransform="capitalize"
                                                    textAlign="start"
                                                    fontFamily={
                                                        developmentData?.branding_props
                                                            ?.brand_font_subtitles || "Montserrat"
                                                    }
                                                >
                                                    {unitSelected?.external_props?.wiggot?.aparment_surface?.toFixed(
                                                        2
                                                    )}{" "}
                                                    m<sup>2</sup>
                                                </Text>
                                            </Flex>
                                            <Text
                                                color={
                                                    developmentData?.branding_props
                                                        ?.sidebar_accent_text ||
                                                    developmentData?.branding_props?.accent_text ||
                                                    "#002B49"
                                                }
                                                fontSize={{ base: "1.6vh", lg: "2vh" }}
                                                fontWeight={400}
                                                textTransform="capitalize"
                                                textAlign="start"
                                                fontFamily={
                                                    developmentData?.branding_props
                                                        ?.brand_font_subtitles || "Montserrat"
                                                }
                                            >
                                                Departamento{" "}
                                                {
                                                    unitSelected?.external_props?.wiggot
                                                        ?.apartment_number
                                                }{" "}
                                                &middot; Nivel{" "}
                                                {
                                                    unitSelected?.dimensiones?.filter(
                                                        (dim) => dim.dimension_name == "Piso"
                                                    )[0]?.item_name
                                                }{" "}
                                                &middot; Vista{" "}
                                                {
                                                    unitSelected?.dimensiones?.filter(
                                                        (dim) => dim.dimension_name == "Vista"
                                                    )[0]?.item_name
                                                }
                                            </Text>
                                        </Stack>
                                        <Stack
                                            mb={{ base: 14, lg: 0 }}
                                            alignSelf="center"
                                            maxW={{ base: "100%", lg: "60%" }}
                                        >
                                            <Flex
                                                gap={{ base: 0, lg: 3 }}
                                                alignItems="center"
                                                wrap="wrap"
                                                textAlign="center"
                                                justifyContent="start"
                                                maxW={{ base: "80vw", lg: "100%" }}
                                                mx="auto"
                                            >
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.bedrooms && (
                                                        <Text
                                                            color={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_accent_text ||
                                                                developmentData?.branding_props
                                                                    ?.accent_text ||
                                                                "#002B49"
                                                            }
                                                            fontSize={{
                                                                base: "1.4vh",
                                                                lg: "1.7vh",
                                                            }}
                                                            fontWeight={400}
                                                            textTransform="capitalize"
                                                            textAlign="center"
                                                            fontFamily={
                                                                developmentData?.branding_props
                                                                    ?.brand_font_subtitles ||
                                                                "Montserrat"
                                                            }
                                                            lineHeight={
                                                                developmentData?.branding_props
                                                                    ?.text?.line_height || ""
                                                            }
                                                        >
                                                            &middot;{" "}
                                                            {unitSelected?.model_features?.bedrooms}{" "}
                                                            {unitSelected?.model_features
                                                                ?.bedrooms > 1
                                                                ? "Recámaras"
                                                                : "Recámara"}
                                                        </Text>
                                                    )}
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.bathrooms && (
                                                        <Text
                                                            color={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_accent_text ||
                                                                developmentData?.branding_props
                                                                    ?.accent_text ||
                                                                "#002B49"
                                                            }
                                                            fontSize={{
                                                                base: "1.4vh",
                                                                lg: "1.7vh",
                                                            }}
                                                            fontWeight={400}
                                                            textTransform="capitalize"
                                                            textAlign="center"
                                                            fontFamily={
                                                                developmentData?.branding_props
                                                                    ?.brand_font_subtitles ||
                                                                "Montserrat"
                                                            }
                                                            lineHeight={
                                                                developmentData?.branding_props
                                                                    ?.text?.line_height || ""
                                                            }
                                                        >
                                                            &middot;{" "}
                                                            {
                                                                unitSelected?.model_features
                                                                    ?.bathrooms
                                                            }{" "}
                                                            {unitSelected?.model_features
                                                                ?.bathrooms > 1
                                                                ? "Baños completos"
                                                                : "Baño completo"}
                                                        </Text>
                                                    )}
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.parking_lots &&
                                                    parseInt(
                                                        unitSelected?.model_features?.parking_lots
                                                    ) > 0 && (
                                                        <Text
                                                            color={
                                                                developmentData?.branding_props
                                                                    ?.sidebar_accent_text ||
                                                                developmentData?.branding_props
                                                                    ?.accent_text ||
                                                                "#002B49"
                                                            }
                                                            fontSize={{
                                                                base: "1.4vh",
                                                                lg: "1.7vh",
                                                            }}
                                                            fontWeight={400}
                                                            textTransform="capitalize"
                                                            textAlign="center"
                                                            fontFamily={
                                                                developmentData?.branding_props
                                                                    ?.brand_font_subtitles ||
                                                                "Montserrat"
                                                            }
                                                            lineHeight={
                                                                developmentData?.branding_props
                                                                    ?.text?.line_height || ""
                                                            }
                                                        >
                                                            &middot;{" "}
                                                            {
                                                                unitSelected?.model_features
                                                                    ?.parking_lots
                                                            }{" "}
                                                            {unitSelected?.model_features
                                                                ?.parking_lots > 1
                                                                ? "Cajones de estacionamiento"
                                                                : "Cajón de estacionamiento"}
                                                        </Text>
                                                    )}

                                                {developmentData?.branding_props
                                                    ?.equipment_text_type == "column" ? (
                                                    <Flex
                                                        direction="column"
                                                        gap="0.5vh"
                                                        pl={{ base: 0, lg: "25%" }}
                                                    >
                                                        {unitSelected?.model_equipment
                                                            ?.slice(
                                                                0,
                                                                unitSelected?.model_equipment
                                                                    ?.length > 6
                                                                    ? 6
                                                                    : unitSelected?.model_equipment
                                                                          ?.length
                                                            )
                                                            .map((item, index) => (
                                                                <Text
                                                                    color={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.sidebar_accent_text ||
                                                                        "#002B49"
                                                                    }
                                                                    fontSize={{
                                                                        base: "1.4vh",
                                                                        lg: "1.7vh",
                                                                    }}
                                                                    fontWeight={400}
                                                                    textTransform="capitalize"
                                                                    textAlign="center"
                                                                    key={index}
                                                                    fontFamily={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.brand_font_subtitles ||
                                                                        "Montserrat"
                                                                    }
                                                                    lineHeight={
                                                                        developmentData
                                                                            ?.branding_props?.text
                                                                            ?.line_height || ""
                                                                    }
                                                                >
                                                                    &middot; {item}
                                                                </Text>
                                                            ))}
                                                    </Flex>
                                                ) : (
                                                    unitSelected?.model_equipment
                                                        ?.slice(
                                                            0,
                                                            unitSelected?.model_equipment?.length >
                                                                6
                                                                ? 6
                                                                : unitSelected?.model_equipment
                                                                      ?.length
                                                        )
                                                        .map((item, index) => (
                                                            <Text
                                                                color={
                                                                    developmentData?.branding_props
                                                                        ?.sidebar_accent_text ||
                                                                    "#002B49"
                                                                }
                                                                fontSize={{
                                                                    base: "1.2vh",
                                                                    lg: "1.7vh",
                                                                }}
                                                                fontWeight={400}
                                                                textTransform="capitalize"
                                                                textAlign="center"
                                                                key={index}
                                                                fontFamily={
                                                                    developmentData?.branding_props
                                                                        ?.brand_font_subtitles ||
                                                                    "Montserrat"
                                                                }
                                                            >
                                                                &middot; {item}
                                                            </Text>
                                                        ))
                                                )}
                                            </Flex>
                                        </Stack>
                                    </Flex>
                                    <Separator
                                        my="0.5vh"
                                        borderColor="black"
                                        opacity={1}
                                        maxW="97%"
                                    />

                                    <Flex justifyContent="center" my="0.5vh">
                                        <Image
                                            src={unitSelected?.render_props}
                                            maxW={{ base: "90vw", lg: "27vw" }}
                                            maxH="40vh"
                                        />
                                    </Flex>
                                    <Stack
                                        alignItems="center"
                                        alignContent="center"
                                        gap={1}
                                        mb="2vh"
                                    >
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_accent_text ||
                                                developmentData?.branding_props?.accent_text ||
                                                "#002B49"
                                            }
                                            fontSize={{ base: "1.6vh", lg: "2.2vh" }}
                                            fontWeight={400}
                                            textTransform="capitalize"
                                            textAlign="start"
                                            fontFamily={
                                                developmentData?.branding_props
                                                    ?.brand_font_subtitles || "Montserrat"
                                            }
                                        >
                                            Departamento{" "}
                                            <strong>
                                                {
                                                    unitSelected?.external_props?.wiggot
                                                        ?.apartment_number
                                                }
                                            </strong>
                                        </Text>
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_accent_text ||
                                                developmentData?.branding_props?.accent_text ||
                                                "#002B49"
                                            }
                                            fontSize={{ base: "1.6vh", lg: "2.2vh" }}
                                            fontWeight={400}
                                            textAlign="start"
                                            fontFamily={
                                                developmentData?.branding_props
                                                    ?.brand_font_subtitles || "Montserrat"
                                            }
                                        >
                                            Precio de{" "}
                                            <strong>
                                                {formatter.format(
                                                    unitSelected?.presale || unitSelected?.sale
                                                )}{" "}
                                                {unitSelected?.presale_currency ||
                                                    unitSelected?.sale_currency}
                                            </strong>
                                        </Text>
                                    </Stack>
                                </Flex>
                            )
                        )}
                    </Box>
                )}
                {(!isGreaterThanMd || (isGreaterThanMd && orientation === "portrait")) &&
                    unitSelected && (
                        <Box minW={{ base: "100%", lg: "40%" }} justifyItems="center">
                            <Flex
                                minW="30vw"
                                maxW={{ base: "100%", lg: "95%" }}
                                justifyItems="center"
                                mt="2vh"
                                direction="column"
                                justifyContent={
                                    developmentData?.branding_props?.details_justify ||
                                    "space-between"
                                }
                                maxH="80vh"
                                overflowY="auto"
                                gap="1vw"
                            >
                                <Stack>
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#000"
                                        }
                                        fontSize={{ base: "2.2vh", lg: "2.4vh" }}
                                        fontWeight={700}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily="Montserrat"
                                    >
                                        Unidad seleccionada
                                    </Text>
                                </Stack>
                                <Stack>
                                    <Flex
                                        gap="1vw"
                                        mt="1vh"
                                        alignItems="center"
                                        justifyContent="center"
                                        alignSelf="center"
                                    >
                                        <Text
                                            color={
                                                "#000" ||
                                                developmentData?.branding_props
                                                    ?.sidebar_accent_text ||
                                                developmentData?.branding_props?.accent_text ||
                                                "#002B49"
                                            }
                                            fontSize={{ base: "2.4vh", lg: "2.6vh" }}
                                            fontWeight={700}
                                            textTransform="capitalize"
                                            textAlign="center"
                                            fontFamily="Poppins"
                                            textShadow="0px 1.5px 1.5px #636363"
                                        >
                                            Modelo {unitSelected?.model_name?.toLowerCase()}
                                        </Text>
                                        <Text
                                            color={
                                                developmentData?.branding_props
                                                    ?.sidebar_accent_text ||
                                                developmentData?.branding_props?.accent_text ||
                                                "#002B49"
                                            }
                                            fontSize={{ base: "2vh", lg: "2.4vh" }}
                                            fontWeight={400}
                                            textTransform="capitalize"
                                            textAlign="center"
                                            fontFamily={
                                                developmentData?.branding_props
                                                    ?.brand_font_subtitles || "Montserrat"
                                            }
                                        >
                                            {unitSelected?.external_props?.wiggot?.aparment_surface?.toFixed(
                                                2
                                            )}{" "}
                                            m<sup>2</sup>
                                        </Text>
                                    </Flex>
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "2vh", lg: "2vh" }}
                                        fontWeight={400}
                                        textTransform="capitalize"
                                        textAlign="center"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        Departamento{" "}
                                        {unitSelected?.external_props?.wiggot?.apartment_number}{" "}
                                        &middot; Nivel{" "}
                                        {
                                            unitSelected?.dimensiones?.filter(
                                                (dim) => dim.dimension_name == "Piso"
                                            )[0]?.item_name
                                        }{" "}
                                        &middot; Vista{" "}
                                        {
                                            unitSelected?.dimensiones?.filter(
                                                (dim) => dim.dimension_name == "Vista"
                                            )[0]?.item_name
                                        }
                                    </Text>
                                </Stack>
                                <Separator
                                    my="1vh"
                                    borderColor="black"
                                    opacity={1}
                                    maxW={{ base: "98%", lg: "95%" }}
                                />

                                <Flex gap="0.5vw">
                                    <Stack
                                        mb={{ base: 4, lg: 0 }}
                                        alignSelf="center"
                                        maxW={{ base: "100%", lg: "100%" }}
                                    >
                                        <List.Root pl={2} w="100%">
                                            <SimpleGrid columns={[1, 2]}>
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.bedrooms && (
                                                        <List.Item
                                                            display="flex"
                                                            alignItems="center"
                                                        >
                                                            <List.Indicator asChild>
                                                                <DotIcon size={30} />
                                                            </List.Indicator>
                                                            <Text
                                                                h="fit-content"
                                                                color={
                                                                    developmentData?.branding_props
                                                                        ?.sidebar_accent_text ||
                                                                    developmentData?.branding_props
                                                                        ?.accent_text ||
                                                                    "#002B49"
                                                                }
                                                                fontSize={{
                                                                    base: "1.8vh",
                                                                    lg: "1.7vh",
                                                                }}
                                                                fontWeight={400}
                                                                textTransform="capitalize"
                                                                textAlign="start"
                                                                fontFamily={
                                                                    developmentData?.branding_props
                                                                        ?.brand_font_subtitles ||
                                                                    "Montserrat"
                                                                }
                                                                lineHeight={
                                                                    developmentData?.branding_props
                                                                        ?.text?.line_height || ""
                                                                }
                                                            >
                                                                {
                                                                    unitSelected?.model_features
                                                                        ?.bedrooms
                                                                }{" "}
                                                                {unitSelected?.model_features
                                                                    ?.bedrooms > 1
                                                                    ? "Recámaras"
                                                                    : "Recámara"}
                                                            </Text>
                                                        </List.Item>
                                                    )}
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.bathrooms && (
                                                        <List.Item
                                                            display="flex"
                                                            alignItems="center"
                                                        >
                                                            <List.Indicator asChild>
                                                                <DotIcon size={30} />
                                                            </List.Indicator>
                                                            <Text
                                                                h="fit-content"
                                                                color={
                                                                    developmentData?.branding_props
                                                                        ?.sidebar_accent_text ||
                                                                    developmentData?.branding_props
                                                                        ?.accent_text ||
                                                                    "#002B49"
                                                                }
                                                                fontSize={{
                                                                    base: "1.8vh",
                                                                    lg: "1.7vh",
                                                                }}
                                                                fontWeight={400}
                                                                textTransform="capitalize"
                                                                textAlign="start"
                                                                fontFamily={
                                                                    developmentData?.branding_props
                                                                        ?.brand_font_subtitles ||
                                                                    "Montserrat"
                                                                }
                                                                lineHeight={
                                                                    developmentData?.branding_props
                                                                        ?.text?.line_height || ""
                                                                }
                                                            >
                                                                {
                                                                    unitSelected?.model_features
                                                                        ?.bathrooms
                                                                }{" "}
                                                                {unitSelected?.model_features
                                                                    ?.bathrooms > 1
                                                                    ? "Baños completos"
                                                                    : "Baño completo"}
                                                            </Text>
                                                        </List.Item>
                                                    )}
                                                {developmentData?.branding_props?.details_type ==
                                                    "text" &&
                                                    unitSelected?.model_features?.parking_lots &&
                                                    parseInt(
                                                        unitSelected?.model_features?.parking_lots
                                                    ) > 0 && (
                                                        <List.Item
                                                            display="flex"
                                                            alignItems="center"
                                                        >
                                                            <List.Indicator asChild>
                                                                <DotIcon size={30} />
                                                            </List.Indicator>
                                                            <Text
                                                                h="fit-content"
                                                                color={
                                                                    developmentData?.branding_props
                                                                        ?.sidebar_accent_text ||
                                                                    developmentData?.branding_props
                                                                        ?.accent_text ||
                                                                    "#002B49"
                                                                }
                                                                fontSize={{
                                                                    base: "1.8vh",
                                                                    lg: "1.7vh",
                                                                }}
                                                                fontWeight={400}
                                                                textTransform="capitalize"
                                                                textAlign="start"
                                                                fontFamily={
                                                                    developmentData?.branding_props
                                                                        ?.brand_font_subtitles ||
                                                                    "Montserrat"
                                                                }
                                                                lineHeight={
                                                                    developmentData?.branding_props
                                                                        ?.text?.line_height || ""
                                                                }
                                                            >
                                                                {
                                                                    unitSelected?.model_features
                                                                        ?.parking_lots
                                                                }{" "}
                                                                {unitSelected?.model_features
                                                                    ?.parking_lots > 1
                                                                    ? "Cajones de estacionamiento"
                                                                    : "Cajón de estacionamiento"}
                                                            </Text>
                                                        </List.Item>
                                                    )}

                                                {developmentData?.branding_props
                                                    ?.equipment_text_type == "column" ? (
                                                    <Flex
                                                        direction="column"
                                                        gap="0.5vh"
                                                        pl={{ base: 0, lg: "25%" }}
                                                    >
                                                        {unitSelected?.model_equipment
                                                            ?.slice(
                                                                0,
                                                                unitSelected?.model_equipment
                                                                    ?.length > 6
                                                                    ? 6
                                                                    : unitSelected?.model_equipment
                                                                          ?.length
                                                            )
                                                            .map((item, index) => (
                                                                <List.Item
                                                                    key={index}
                                                                    display="flex"
                                                                    alignItems="center"
                                                                >
                                                                    <List.Indicator asChild>
                                                                        <DotIcon size={30} />
                                                                    </List.Indicator>
                                                                    <Text
                                                                        h="fit-content"
                                                                        color={
                                                                            developmentData
                                                                                ?.branding_props
                                                                                ?.accent_text ||
                                                                            "#002B49"
                                                                        }
                                                                        fontSize={{
                                                                            base: "1.8vh",
                                                                            lg: "1.7vh",
                                                                        }}
                                                                        fontWeight={400}
                                                                        textTransform="capitalize"
                                                                        textAlign="start"
                                                                        fontFamily={
                                                                            developmentData
                                                                                ?.branding_props
                                                                                ?.brand_font_subtitles ||
                                                                            "Montserrat"
                                                                        }
                                                                        lineHeight={
                                                                            developmentData
                                                                                ?.branding_props
                                                                                ?.text
                                                                                ?.line_height || ""
                                                                        }
                                                                    >
                                                                        {item}
                                                                    </Text>
                                                                </List.Item>
                                                            ))}
                                                    </Flex>
                                                ) : (
                                                    unitSelected?.model_equipment
                                                        ?.slice(
                                                            0,
                                                            unitSelected?.model_equipment?.length >
                                                                6
                                                                ? 6
                                                                : unitSelected?.model_equipment
                                                                      ?.length
                                                        )
                                                        .map((item, index) => (
                                                            <List.Item
                                                                key={index}
                                                                display="flex"
                                                                alignItems="center"
                                                            >
                                                                <List.Indicator asChild>
                                                                    <DotIcon size={30} />
                                                                </List.Indicator>
                                                                <Text
                                                                    h="fit-content"
                                                                    fontSize={{
                                                                        base: "1.8vh",
                                                                        lg: "1.7vh",
                                                                    }}
                                                                    fontWeight={400}
                                                                    textTransform="capitalize"
                                                                    textAlign="start"
                                                                    fontFamily={
                                                                        developmentData
                                                                            ?.branding_props
                                                                            ?.brand_font_subtitles ||
                                                                        "Montserrat"
                                                                    }
                                                                >
                                                                    {item}
                                                                </Text>
                                                            </List.Item>
                                                        ))
                                                )}
                                            </SimpleGrid>
                                        </List.Root>
                                    </Stack>
                                </Flex>
                                <Flex justifyContent="center" my="0.5vh">
                                    <Image
                                        src={unitSelected?.render_props}
                                        maxW={{ base: "85vw", lg: "27vw" }}
                                        maxH="35vh"
                                    />
                                </Flex>
                                <Stack alignItems="center" alignContent="center" gap={1} mb="2vh">
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "2.2vh", lg: "2vh" }}
                                        fontWeight={400}
                                        textTransform="capitalize"
                                        textAlign="start"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        Departamento{" "}
                                        <strong>
                                            {unitSelected?.external_props?.wiggot?.apartment_number}
                                        </strong>
                                    </Text>
                                    <Text
                                        color={
                                            developmentData?.branding_props?.sidebar_accent_text ||
                                            developmentData?.branding_props?.accent_text ||
                                            "#002B49"
                                        }
                                        fontSize={{ base: "2.2vh", lg: "2vh" }}
                                        fontWeight={400}
                                        textAlign="start"
                                        fontFamily={
                                            developmentData?.branding_props?.brand_font_subtitles ||
                                            "Montserrat"
                                        }
                                    >
                                        Precio de{" "}
                                        <strong>
                                            {formatter.format(
                                                unitSelected?.presale || unitSelected?.sale
                                            )}{" "}
                                            {unitSelected?.presale_currency ||
                                                unitSelected?.sale_currency}
                                        </strong>
                                    </Text>
                                </Stack>
                            </Flex>
                        </Box>
                    )}
            </Flex>
        </Box>
    );
};

export default ContentSelection;
